<template>
  <div class="w-full items-center flex flex-col" ref="modalBody">
    <div class="flex flex-col w-full">
      <div class="flex flex-col w-full mobile:flex-col gap-y-4 flex-1">
        <div class="flex w-full gap-x-2 mobile:flex-col gap-y-2">
          <div class="flex flex-col w-1/2 gap-y-2 mobile:w-full">
            <div class="data-container">
              <div class="data-container-header">
                <h4>Üldinfo</h4>
              </div>
              <div class="data-container-content mobile:gap-y-4 text-sm">
                <div class="flex gap-x-2 mobile:flex-col mobile:gap-y-4">
                  <div class="flex flex-col gwd-form w-1/2 mobile:w-full">
                    <div class="form-group">
                      <gwd-formlabel
                        title="Pealkiri"
                        :required="false"
                        :valid="!$v.fields.title.$invalid"
                        :error="$v.fields.title.$error"
                        :error-text="
                          fields.title && $v.fields.title.$params.maxLength
                            ? 'Pealkiri on liiga pikk'
                            : ''
                        "
                      />
                      <gwd-textarea
                        class="shadow focus:shadow-outline"
                        :class="
                          $v.$error && $v.fields.title.$invalid
                            ? 'shadow-dangeroutline'
                            : ''
                        "
                        v-model="fields.title"
                        :max-length="128"
                        :background="true"
                        :required="!fields.title && !fields.description"
                      />
                    </div>
                    <div class="gwd-form-hor-group gap-x-2">
                      <gwd-formlabel title="Tellimus" />
                      <div class="flex items-center gap-x-2">
                        <button
                          class="btn-primary"
                          @click="
                            $store.commit(
                              'modals/addTaskModal/setShowProjectSelector',
                              true
                            )
                          "
                          v-if="!selectedProject && !relatedProject"
                        >
                          <span class="label">Vali</span>
                        </button>
                        <button
                          class="btn-primary"
                          @click="
                            $store.commit(
                              'modals/addTaskModal/setShowNewProjectModal',
                              true
                            )
                          "
                          v-if="!selectedProject && !relatedProject"
                        >
                          <span class="label">Lisa uus</span>
                        </button>
                        <span>{{
                          relatedProject
                            ? relatedProject.title
                            : selectedProject
                            ? selectedProject.title
                            : ""
                        }}</span>
                        <button
                          v-if="!relatedProject && selectedProject"
                          @click="
                            () => {
                              setProject(null);
                              $store.commit(
                                'modals/addTaskModal/setShowProjectSelector',
                                true
                              );
                            }
                          "
                          class="btn-primary"
                        >
                          <span class="icon typcn typcn-plus"></span>
                          <span class="label">Vali uus</span>
                        </button>
                        <button
                          v-if="!relatedProject && selectedProject"
                          @click="setProject(null)"
                          class="btn-danger"
                        >
                          <span class="icon typcn typcn-times"></span>
                          <span class="label">Tühjenda</span>
                        </button>
                      </div>
                    </div>
                    <div v-if="selectedProject" class="flex gap-x-2">
                      <h4>Klient</h4>
                      <router-link
                        :to="`/clients/${selectedProject.client_id}`"
                        target="_blank"
                      >
                        <span>
                          {{
                            selectedProject.client_name
                              ? selectedProject.client_name
                              : selectedProject.client.name
                              ? selectedProject.client.name
                              : "?"
                          }}
                        </span>
                      </router-link>
                    </div>
                    <div class="gwd-form-hor-group gap-x-2" ref="payerGroup">
                      <gwd-formlabel title="Maksja" />
                      <button
                        class="btn-primary"
                        v-if="!fields.payer"
                        @click="
                          $store.dispatch(
                            'modals/addTaskModal/showPayerSelector',
                            true
                          )
                        "
                      >
                        <span class="label">Vali</span>
                      </button>
                      <div
                        v-if="
                          fields.payer && Object.keys(fields.payer).length > 0
                        "
                        class="flex items-center w-full gap-x-2"
                      >
                        <span>{{ fields.payer.name }}</span>
                        <button class="btn-danger" @click="resetPayer">
                          <span class="label">Muuda</span>
                        </button>
                      </div>
                    </div>
                    <div class="flex items-center">
                      <gwd-checkbox
                        class="mr-2"
                        v-model="fields.is_public"
                        size="6"
                      />
                      <span>Nähtav kõikidele töötajatele</span>
                    </div>
                    <div class="flex items-center">
                      <gwd-checkbox
                        class="mr-2"
                        v-model="fields.publish"
                        size="6"
                      />
                      <span>Salvesta aktiivsena</span>
                    </div>
                    <div class="flex items-center" v-if="relatedProject">
                      <gwd-checkbox
                        class="mr-2"
                        v-model="fields.visible_to_client"
                        size="6"
                      />
                      <span>Nähtav kliendile</span>
                    </div>
                  </div>
                  <div class="flex w-1/2 mobile:w-full">
                    <add-task-time-selector ref="timeSelector" />
                  </div>
                </div>
              </div>
            </div>
            <div class="data-container">
              <div class="data-container-header">
                <h4>Kirjeldus</h4>
                <div
                  v-if="
                    !formatClicked &&
                    fields.description &&
                    fields.description.length > 500
                  "
                  class="flex justify-end ml-auto text-sm"
                >
                  <button class="btn-primary" @click="compressDescription">
                    <span class="label">Vorminda tekst</span>
                  </button>
                </div>
              </div>
              <div class="data-container-content text-sm">
                <div class="form-group mb-2">
                  <gwd-textarea
                    v-model="fields.description"
                    :background="true"
                    :max-length="2048"
                    :required="!fields.title && !fields.description"
                    :enable-paste-compress="true"
                    ref="fieldDescription"
                    @change="formatClicked = false"
                  />
                </div>
              </div>
              <div class="data-container-header">
                <h4>Info töödejuhatajatele</h4>
              </div>
              <div class="data-container-content text-sm">
                <div class="form-group mb-2">
                  <gwd-textarea
                    v-model="fields.manager_description"
                    :background="true"
                    :max-length="1024"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="flex flex-col gap-y-2 w-1/2 mobile:w-full">
            <div class="data-container">
              <div class="data-container-header">
                <h4>Asukoht</h4>
                <div
                  v-if="
                    $refs.addTaskLocationSelector &&
                    fields.location &&
                    fields.endLocation
                  "
                  class="flex ml-auto text-sm"
                >
                  <button
                    class="btn-primary gap-x-2"
                    @click="$refs.addTaskLocationSelector.switchLocations"
                  >
                    <span class="typcn typcn-arrow-shuffle" />
                    <span class="label">Vaheta asukohad</span>
                  </button>
                </div>
              </div>
              <div class="data-container-content text-sm">
                <add-task-location-selector ref="addTaskLocationSelector" />
              </div>
            </div>
            <div class="data-container">
              <div class="data-container-header">
                <h4>Sildid</h4>
              </div>
              <div class="data-container-content text-sm">
                <add-task-tag-selector />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="w-full mx-auto error-box"
        ref="errorBox"
        v-if="$v.$error && $v.$invalid"
      >
        <div class="flex w-1/12 justify-center items-center">
          <span class="typcn typcn-times text-4xl leading-none"></span>
        </div>
        <div class="flex w-11/12 items-center">
          <span v-if="$v.fields.title.$invalid">Palun sisestage pealkiri</span>
          <span v-if="$v.fields.description.$invalid">
            Kirjeldus võib olla kuni 1024 tähemärki
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ee } from "vuejs-datepicker/dist/locale";
import moment from "moment";
import { maxLength } from "vuelidate/lib/validators";
import "moment/locale/et";
import AddTaskTimeSelector from "./AddTaskTimeSelector.vue";
import { mapGetters, mapState } from "vuex";
import AddTaskLocationSelector from "@/components/tasks/AddTaskLocationSelector";
import AddTaskTagSelector from "@/components/tasks/AddTaskTagSelector.vue";
import { set } from "lodash";
export default {
  props: {
    hasPresetData: Boolean,
    presetData: {
      type: [Object, Array, Date],
      default: () => {
        return {};
      },
    },
    relatedProject: {
      type: String,
      default: null,
    },
    projectLocation: {
      type: Object,
      default: () => {
        return {};
      },
    },
    displaySaveButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      ee: ee,
      topCalendarShowing: false,
      bottomCalendarShowing: false,
      selectSeparatePayer: false,
      formatClicked: false,
    };
  },
  components: {
    AddTaskTagSelector,
    AddTaskTimeSelector,
    AddTaskLocationSelector,
  },
  async mounted() {
    if (!this.companyWorkers)
      await this.$store.dispatch("companyVariables/retrieveWorkers");
    if (this.inputData) {
      if (this.inputData.project) this.setProject(this.inputData.project);
      if (
        this.inputData.related_object &&
        this.inputData.related_object.type === "Project"
      )
        this.retrieveProject(this.inputData.related_object.object_uuid);
      for (const [key, value] of Object.entries(this.inputData)) {
        if (
          [
            "description",
            "all_day",
            "is_public",
            "payer",
            "manager_description",
            "tags",
          ].includes(key)
        ) {
          set(this.fields, key, value);
        } else if (key === "extra_locations") {
          await this.$store.dispatch(
            "modals/addTaskModal/setExtraLocations",
            value
          );
        } else if (key === "location") {
          this.$refs.addTaskLocationSelector.setStartLocation(value);
        } else if (key === "end_location") {
          this.$refs.addTaskLocationSelector.setEndLocation(value);
        } else if (key === "worker_amount") {
          this.$emit("workerAmountFromCopy", value);
        } else if (key === "start_time" && value) {
          this.$refs.timeSelector.handleCopyFromTask(
            value,
            this.inputData["end_time"]
          );
        } else if (key === "sub_tasks") {
          this.$emit("copyTaskSubTasks", value);
        } else if (key === "title") {
          let title = value;
          if (value.match("\\d{7}/\\d+ - ")) {
            const index = value.indexOf("-");
            title = value.substring(index + 2, value.length);
          } else if (value.match("\\d{7} - ")) {
            const index = value.indexOf("-");
            title = value.substring(index + 2, value.length);
          }
          set(this.fields, key, title);
        }
      }
    }
    if (Object.keys(this.projectLocation).length > 0)
      this.fields.location = this.projectLocation;
  },
  methods: {
    compressDescription() {
      this.fields.description = this.fields.description
        .replace(/\n+/g, "\n") // Replace multiple newlines with a single one
        .replace(/[ \t]+/g, " ") // Replace multiple spaces/tabs with a single space
        .replace(/\n[ \t]+/g, "\n") // Remove leading spaces/tabs after newlines
        .replace(/[ \t]+\n/g, "\n") // Remove trailing spaces/tabs before newlines
        .trim();
      this.$nextTick(() => {
        this.$refs.fieldDescription.resize();
      });
      this.formatClicked = true;
    },
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY");
    },
    setProject(project) {
      this.$store.dispatch("modals/addTaskModal/setProject", project);
    },
    resetPayer() {
      this.fields.payer = null;
    },
    retrieveProject(projectUuid) {
      this.apiRequest(`company/drafts/${projectUuid}/`, "get", true).then(
        (res) => {
          this.setProject(res.data);
        }
      );
    },
  },
  computed: {
    ...mapState({
      fields: (state) => state.modals.addTaskModal.fields,
      extraLocations: (state) => state.modals.addTaskModal.extraLocations,
      equipmentList: (state) => state.modals.addTaskModal.equipmentList,
    }),
    ...mapGetters({
      companyWorkers: "companyVariables/companyWorkers",
      inputData: "modals/addTaskModal/inputData",
      selectedProject: "modals/addTaskModal/project",
    }),
  },
  validations() {
    return {
      fields: {
        title: {
          maxLength: maxLength(128),
        },
        description: {
          maxLength: maxLength(1024),
        },
      },
    };
  },
};
</script>

<style lang="scss"></style>
